import { Box } from '@mui/material'
import { ProgressReportsOverview } from './ProgressReportsOverview'
import { Route, Routes } from 'react-router-dom'
import { OrgProgressReports } from './ProgressReports'
import { MidYear } from './MidYear/MidYear'
import { MidYearSummary } from './MidYear/Summary/MidYearSummary'

export const ProgressReportsTab = (): JSX.Element => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<ProgressReportsOverview />} />
        <Route path="/Organization/:orgId" element={<OrgProgressReports />} />
        <Route path="/Organization/:orgId/MidYear" element={<MidYear/>} />
        <Route path="/Organization/:orgId/MidYear/Summary" element={<MidYearSummary/>} />
      </Routes>

    </Box>
  )
}
